import React from 'react';

const URGENCY_COLORS = {
  red: { dot: 'bg-red-500', border: 'border-red-900/40', bg: 'hover:bg-red-950/20' },
  yellow: { dot: 'bg-yellow-500', border: 'border-yellow-900/30', bg: 'hover:bg-yellow-950/20' },
  green: { dot: 'bg-green-500', border: 'border-green-900/20', bg: 'hover:bg-gray-800/60' },
};

function Avatar({ name, urgency }) {
  const initials = name ? name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase() : '?';
  const colors = { red: 'bg-red-800 text-red-200', yellow: 'bg-yellow-800 text-yellow-200', green: 'bg-gray-700 text-gray-200' };
  return (
    <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-bold ${colors[urgency] || colors.green}`}>
      {initials}
    </div>
  );
}

function stripMarkdown(text) {
  if (!text) return null;
  return text
    .replace(/#{1,6} /g, '')
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/`(.+?)`/g, '$1')
    .replace(/^- /gm, '')
    .replace(/\n+/g, ' ')
    .trim()
    .substring(0, 100);
}

export default function CaseCard({ record, onClick }) {
  const c = URGENCY_COLORS[record.urgency] || URGENCY_COLORS.green;
  return (
    <button onClick={onClick}
      className={`w-full text-left px-4 py-3 border-b border-gray-800 ${c.bg} transition-colors flex gap-3 items-start`}>
      <div className="relative">
        <Avatar name={record.title} urgency={record.urgency} />
        <span className={`absolute -top-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-gray-900 ${c.dot}`} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="text-gray-100 text-sm font-medium truncate">{record.title}</span>
          <span className="text-gray-500 text-[10px] flex-shrink-0">{record.record_type_name}</span>
        </div>
        {record.critical_note && (
          <p className={`text-xs mt-0.5 truncate ${record.urgency === 'red' ? 'text-red-400' : record.urgency === 'yellow' ? 'text-yellow-400' : 'text-gray-400'}`}>
            {record.urgency === 'red' ? '⚠️ ' : record.urgency === 'yellow' ? '⏰ ' : '• '}{record.critical_note}
          </p>
        )}
        {record.last_ai_preview && (
          <p className="text-gray-500 text-[11px] mt-0.5 truncate italic">"{stripMarkdown(record.last_ai_preview)}"</p>
        )}
      </div>
    </button>
  );
}
